import { createIcon } from "@chakra-ui/react";

export const HomeIcon = createIcon({
  displayName: "HomeIcon",
  viewBox: "0 0 25 24",
  defaultProps: {
    width: "24px",
    height: "24px",
  },
  path: (
    <>
      <g clipPath="url(#clip0_9708_1119)">
        <path
          d="M4.5 13H10.5C11.05 13 11.5 12.55 11.5 12V4C11.5 3.45 11.05 3 10.5 3H4.5C3.95 3 3.5 3.45 3.5 4V12C3.5 12.55 3.95 13 4.5 13ZM4.5 21H10.5C11.05 21 11.5 20.55 11.5 20V16C11.5 15.45 11.05 15 10.5 15H4.5C3.95 15 3.5 15.45 3.5 16V20C3.5 20.55 3.95 21 4.5 21ZM14.5 21H20.5C21.05 21 21.5 20.55 21.5 20V12C21.5 11.45 21.05 11 20.5 11H14.5C13.95 11 13.5 11.45 13.5 12V20C13.5 20.55 13.95 21 14.5 21ZM13.5 4V8C13.5 8.55 13.95 9 14.5 9H20.5C21.05 9 21.5 8.55 21.5 8V4C21.5 3.45 21.05 3 20.5 3H14.5C13.95 3 13.5 3.45 13.5 4Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9708_1119">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </>
  ),
});
